import WebServiceWrapper from "./WebServiceWrapper";
function Verify(payload) {
    return WebServiceWrapper.Post("/recaptcha/Verify", payload);
}
export const RecaptchaService = {
    Verify
};